module.exports = __webpack_public_path__ + "static/media/8.1.f6415f2d.png";